import SJImageCell from '@/components/SJImageCell'
import { getPlayers } from '@/services/player'
import { Player, PlayerListRes } from '@/services/types/player'
import user from '@/stores/user'
import { PullToRefresh } from 'antd-mobile'
import { sleep } from 'antd-mobile/es/utils/sleep'
import { observer } from 'mobx-react'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import store from 'store'

type PlayerWithCheck = Player & {
  checked: boolean
}
type State = {
  playerId: string
}
const PlayerSwitch = () => {
  document.title = '棋手切换'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: State }

  const [players, setPlayers] = useState<PlayerWithCheck[]>([])

  const fetchPlayers = useCallback(async () => {
    try {
      const res = (await getPlayers()) as unknown as PlayerListRes
      console.log(res.list)
      const list = res.list.map((item) => {
        return { ...item, checked: state.playerId === item.playerId }
      })
      setPlayers(list)
    } catch (error) {}
  }, [state.playerId])

  useEffect(() => {
    fetchPlayers()
  }, [fetchPlayers])

  const handleSwitch = async (player: Player) => {
    players.forEach((o) => {
      o.checked = o.playerId === player.playerId
    })
    setPlayers([...players])
    user.curPlayer = player
    store.set('curPlayer', player)
    await sleep(500)
    navigate(-1)
  }

  return (
    <div className="page player-switch">
      <PullToRefresh onRefresh={fetchPlayers}>
        <div className="main">
          {players.map((item) => {
            return (
              <SJImageCell
                type="check"
                key={item.playerId}
                image={item.avatarUrl}
                name={item.name || '棋手'}
                role={user.userPlayer.playerId === item.playerId ? '管理员' : '棋手'}
                checked={item.checked}
                onClick={() => handleSwitch(item)}
              ></SJImageCell>
            )
          })}
        </div>
        {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore}></InfiniteScroll> */}
      </PullToRefresh>
    </div>
  )
}

export default observer(PlayerSwitch)
